import { Card, Grid, Text } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import FormSearchUnblock from '../../../components/forms/FormSearchUnblock';
import Button from '../../../components/elements/Button';
import { clearRedux, failedAction, fetchDataCustomerUnblock, fetchProcessUnblock, fetchSearchProcessUnblock } from '../actions';
import { fetchSessionProtection } from '../../../components/layouts/PageBase/actions';
import { useSelector } from 'react-redux';
import { RenderModalConflict, RenderModalSummaryCustomer } from './Modals';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { ToastrContext } from '../../../contexts';

const OnProcessCustomer = (
  {
    dispatch = () => {},
    dataVerif = {}
  }
) => {
  const { dataCustomerUnblock, messageCustomerUnblock, dataDetailCustomerUnblock } =
     useSelector(({ customerSubmissionUnblock }) =>
       customerSubmissionUnblock);
  const { setToastr } = useContext(ToastrContext);
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState({
    type: '',
    opened: false
  });
  const handleSearch = () => {
    if(search.length < 16){
      dispatch(failedAction('LESS_THAN_16', 'CustomerUnblock'));
    }else{
      dispatch(fetchDataCustomerUnblock({
        nationalityId: search,
        status: 'PENDING',
      })).then(() => setModal({
        type: 'summary',
        opened: true
      })).catch(e => e);
    }
  };
  const errors = {
    NOT_FOUND: 'NIK pelanggan tidak ditemukan',
    LESS_THAN_16: 'NIK kurang dari 16 digit'
  };
  const onCloseModal = () => setModal({ type: '', opened: false });

  const searchHandler = (response) => {
    onCloseModal();
    if(response.success){
      navigate(`/submission-unblock/detail/${search}?type=search`);
    }else if(response.status === 'CONFLICT'){
      setModal({
        type: 'conflict',
        opened: true
      });
    }else{
      setToastr({
        type: 'danger',
        desc: 'Terjadi kesalahan pada sistem kami',
        visible: true,
      });
    }
  };

  const handleConfirm = () => {
    dispatch(fetchSearchProcessUnblock({ nationalityId: search }, searchHandler));
  };
  useEffect(() => {
    dispatch(fetchSessionProtection());
  }, []);
  return (
    <Grid gutter={12}>
      <Grid.Col h="auto" span={8}>
        <Card h="100%" p="xl" withBorder>
          <img
            height="100"
            src="/assets/illu-verification.svg"
            width="100"
          />
          <Text fw={500} fz={24}>Verifikasi Pengajuan Buka Blokir</Text>
          {dataVerif.needVerification ? <Text c="#52575C" fz={18} mb={16}>
            Terdapat {<b>{dataVerif?.needVerification} Pengajuan</b>} yang perlu diverifikasi.
             Silakan mulai verifikasi pengajuan buka blokir
          </Text> :
            <Text c="#52575C" fz={18} mb={16}>
            Tidak ada pengajuan yang perlu diverifikasi saat ini</Text>}
          <Button fullWidth
            onClick={() => {
              dispatch(fetchProcessUnblock()).then(() => {
                navigate(`/submission-unblock/detail/${dataDetailCustomerUnblock.requestId}`);
              }).catch(e => {
                setToastr({
                  desc: e.message || 'Terjadi kesalahan pada sistem kami',
                  type: 'danger',
                  visible: true,
                });
              });
            }}>
            Mulai Verifikasi</Button>
        </Card>
      </Grid.Col>
      <Grid.Col span={4}>
        <Card p="xl" withBorder>
          <img
            height="100"
            src="/assets/illu-setting-merchant.svg"
            width="100"
          />
          <Text fw={500} fz={24} mb={16}>Cari Data</Text>
          <FormSearchUnblock
            btnVariant="primary-500"
            clearRedux={() => clearRedux('messageCustomerUnblock')}
            data={{ code: messageCustomerUnblock && 400 }}
            handleSearch={handleSearch}
            messageError={errors[messageCustomerUnblock] || ''}
            search={search}
            setSearch={setSearch}
          />
        </Card>
      </Grid.Col>
      {modal.type === 'summary' && <RenderModalSummaryCustomer data={dataCustomerUnblock} onClose={onCloseModal} onConfirm={handleConfirm} opened={modal.opened}/>}
      {modal.type === 'conflict' && <RenderModalConflict onClose={onCloseModal} opened={modal.opened} />}
    </Grid>
  );
};

export default OnProcessCustomer;

OnProcessCustomer.propTypes = {
  dataVerif: PropTypes.object,
  dispatch: PropTypes.func
};
